import script from "./FaceBookFeeds.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceBookFeeds.vue?vue&type=script&setup=true&lang=js"

import "./FaceBookFeeds.vue?vue&type=style&index=0&id=8d9799ee&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d9799ee"]])

export default __exports__